// extracted by mini-css-extract-plugin
export default {"container":"style_container__eOPO9","infoPPN":"style_infoPPN__tVUu6","content":"style_content__4ql05"};